import { takeEvery, put , call, select} from 'redux-saga/effects';
import { getApprovalList } from '../actions/ApprovalListActions';
import ApprovalService from "../services/ApprovalService";
import {enableSuccessToastInfo,enableRejectToastInfo,showApiErrorMessage} from "../actions/ToastActions";
import {createNewOrdersAnalyticsLog} from "../services/approval-util";
import {createAddonsAnalyticsLog} from "../services/approval-util-add-license";
import * as appConstants from '../constants/AppConstants';


const getSelectedTab = state => state.ApprovalListReducer.selectedTab;
const approvalListReducer = (state) => state.ApprovalListReducer;
const AppReducer = (state) => state.AppReducer;

export function* approveRequestSaga(){

    yield takeEvery('APPROVAL_REQUEST', function* (action){
        const selectedTab = yield select(getSelectedTab);
        const { approvalId } = action;
        yield call(approveRequestActionSaga,approvalId, selectedTab);
    })
        
}

export function* approveRequestActionSaga(approvalId, selectedTab){

    const approvalListProcessor = yield select(approvalListReducer);
    const AppReducerProcessor = yield select(AppReducer);
    const featureFlags = AppReducerProcessor.featureFlags;
    const approvalList = approvalListProcessor.approvalList;
    let selectedApproval = [];
    if(approvalList && approvalList.length > 0){
        selectedApproval = approvalList.filter((item) => item.approvalId === approvalId)
    }
    try{
        const response = yield call(ApprovalService.approveRequest, approvalId);
        if (response.data) {
            //show toast message
            yield put(enableSuccessToastInfo(true));
            let isAnalyticsFeatureEnabled = featureFlags.indexOf(appConstants.ENABLE_APPROVAL_ANALYTICS_LOG) > -1;

            if(isAnalyticsFeatureEnabled){
                if(selectedApproval[0] && selectedApproval[0].flowId === 'NEW_ORDERS'){
                    createNewOrdersAnalyticsLog(selectedApproval[0])
                }
                if(selectedApproval[0] && (selectedApproval[0].flowId === 'ADD_LICENSE' || selectedApproval[0].flowId === 'TEAM_CHANGE_PLAN')){
                    createAddonsAnalyticsLog(selectedApproval[0])
                }
            }
            yield put(getApprovalList(selectedTab));
        }
    }catch(error){
        yield put(showApiErrorMessage(true));
    }
    
}

export function* rejectRequestSaga(){

    yield takeEvery('REJECT_REQUEST', function* (action){
        const selectedTab = yield select(getSelectedTab);
        const { approvalId } = action;
        yield call(rejectRequestActionSaga,approvalId, selectedTab);
    })
        
}

export function* rejectRequestActionSaga(approvalId, selectedTab){
    try{
        const response = yield call(ApprovalService.rejectRequest, approvalId);
        if (response.data) {
           //show toast message
           yield put(enableRejectToastInfo(true));

           yield put(getApprovalList(selectedTab));
        }
    }catch(error){
        yield put(showApiErrorMessage(true));
    }
    
}
